import { Trans, useTranslation } from 'react-i18next';
import EnrollmentCard from '../components/EnrollmentCard';
import PageWrapper from '../components/PageWrapper';
import '../customerStyles/disney.less';

function EnrollmentLandingPage() {
    const { t } = useTranslation();

    return (
        <div className="page-wrapper enrollment-page">
            <div className="enrollment-page__columns">
                <div className="enrollment-page__first-column">
                    <aside className="info-panel">
                        <div className="info-panel__container">
                            <header className="info-panel__header">
                                <div className="info-panel__title">
                                    {t('enrollmentLandingPageTitle')}
                                </div>

                                <div className="info-panel__description">
                                    <Trans
                                        i18nKey={
                                            'enrollmentLandingPageDescription'
                                        }
                                        components={[
                                            // eslint-disable-next-line jsx-a11y/anchor-has-content
                                            <a
                                                href="https://disneyworld.disney.go.com/guest-services/airport-luggage-transfer"
                                                target="_blank"
                                                rel="noreferrer"
                                            />,
                                        ]}
                                    />
                                </div>
                            </header>
                            <hr className="info-panel__divider" />
                            <div className="info-panel__body">
                                <div className="info-panel__bullet-header">
                                    {t('howItWorks')}
                                </div>
                                <div className="info-panel__subheader">
                                    {t('enrollmentCriteriaSubheader1')}
                                </div>
                                <div className="info-panel__list">
                                    <li className="info-panel__list-item">
                                        <span
                                            className="info-panel__check"
                                            aria-hidden
                                        >
                                            ✓
                                        </span>
                                        <span>{t('enrollmentCriteria1')}</span>
                                    </li>
                                </div>
                                <div className="info-panel__list">
                                    <li className="info-panel__list-item">
                                        <span
                                            className="info-panel__check"
                                            aria-hidden
                                        >
                                            ✓
                                        </span>
                                        <span>{t('enrollmentCriteria2')}</span>
                                    </li>
                                </div>
                                <div className="info-panel__list">
                                    <li className="info-panel__list-item">
                                        <span
                                            className="info-panel__check"
                                            aria-hidden
                                        >
                                            ✓
                                        </span>
                                        <span>{t('enrollmentCriteria3')}</span>
                                    </li>
                                </div>
                                <div className="info-panel__list">
                                    <li className="info-panel__list-item">
                                        <span
                                            className="info-panel__check"
                                            aria-hidden
                                        >
                                            ✓
                                        </span>
                                        <span>{t('enrollmentCriteria4')}</span>
                                    </li>
                                </div>
                            </div>
                            <div className="info-panel__list">
                                <li className="info-panel__list-item">
                                    <span
                                        className="info-panel__check"
                                        aria-hidden
                                    >
                                        ✓
                                    </span>
                                    <span>{t('enrollmentCriteria5')}</span>
                                </li>
                            </div>
                            <div className="info-panel__subheader">
                                <Trans i18nKey="enrollmentCriteriaSubheader2" />
                            </div>
                            <div className="info-panel__list">
                                <li className="info-panel__list-item">
                                    <span
                                        className="info-panel__check"
                                        aria-hidden
                                    >
                                        ✓
                                    </span>
                                    <span>{t('enrollmentCriteria6')}</span>
                                </li>
                            </div>
                            <div className="info-panel__list">
                                <li className="info-panel__list-item">
                                    <span
                                        className="info-panel__check"
                                        aria-hidden
                                    >
                                        ✓
                                    </span>
                                    <span>{t('enrollmentCriteria7')}</span>
                                </li>
                            </div>
                            <div className="info-panel__list">
                                <li className="info-panel__list-item">
                                    <span
                                        className="info-panel__check"
                                        aria-hidden
                                    >
                                        ✓
                                    </span>
                                    <span>{t('enrollmentCriteria8')}</span>
                                </li>
                            </div>
                            <hr className="info-panel__divider" />
                            <div className="info-panel__list">
                                <p>
                                    <span>{t('infoPanelAssistance1')}</span>{' '}
                                    <a href="tel:+4075057443">(407) 505-7443</a>{' '}
                                    <span>{t('infoPanelAssistance2')}</span>
                                </p>
                            </div>
                        </div>
                    </aside>
                    <div className="youth-group-description">
                        <Trans
                            i18nKey={'youthGroupDescription'}
                            components={[
                                // eslint-disable-next-line jsx-a11y/anchor-has-content
                                <a
                                    href="https://share.teamforms.app/form/NzFhZDM3ZjctMDQ3ZS00ZGVkLWJjYmItOTA0YzBlYmM0NmRmOjRlZDQ4NjUxLWE1NTQtNDRhMS04MWI4LTJiNzIxYjQ1MTZmNDphMzE0ZjkzYS05NGZhLTQ1ZDEtOTBiYy1mMTVmZmQ1OTE5Njg="
                                    rel="noreferrer"
                                />,
                            ]}
                        />
                    </div>
                </div>
                <EnrollmentCard />
            </div>
        </div>
    );
}

export default EnrollmentLandingPage;
